module.exports = __webpack_public_path__ + "img/placeholder.96a9399b.png";